import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var GoogleColoredBrand = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  var numericSize = size === 'medium' ? 16 : size === 'small' ? 14 : 12;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: numericSize,
    ref: ref,
    role: "img",
    width: numericSize,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Google') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("g", {
    fillRule: "nonzero",
    fill: "none"
  }, ___EmotionJSX("path", {
    fill: "#4285F4",
    d: "M17.537 9.156c0-.59-.048-1.183-.15-1.763H9.205v3.34h4.685a4.015 4.015 0 01-1.734 2.636v2.168h2.796c1.641-1.511 2.585-3.742 2.585-6.381z"
  }), ___EmotionJSX("path", {
    fill: "#34A853",
    d: "M9.205 17.63c2.34 0 4.312-.767 5.75-2.093l-2.795-2.168c-.778.53-1.782.83-2.952.83-2.263 0-4.182-1.528-4.87-3.58H1.453v2.234a8.676 8.676 0 007.752 4.778z"
  }), ___EmotionJSX("path", {
    fill: "#FBBC04",
    d: "M4.334 10.619a5.196 5.196 0 010-3.322V5.063H1.453a8.682 8.682 0 000 7.79l2.881-2.234z"
  }), ___EmotionJSX("path", {
    fill: "#EA4335",
    d: "M9.205 3.715a4.714 4.714 0 013.327 1.3L15.01 2.54A8.337 8.337 0 009.205.282a8.673 8.673 0 00-7.752 4.781l2.881 2.234c.686-2.056 2.608-3.582 4.87-3.582z"
  })));
});
GoogleColoredBrand.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf(['xsmall', 'small', 'medium']),
  title: _pt.string,
  titleId: _pt.string
} : {};
export default GoogleColoredBrand;